<script lang="ts">
  import { onMount } from 'svelte'
  import Navbar from '@/components/appDriver/Navbar.svelte'
  import ProfileCard from '@/components/appDriver/ProfileCard.svelte'
  import { currentPage, enquiryResult, topupPaymentGatewayResult, topupRequest } from '@/components/appDriver/store'
  import PageTopupAmount from '@/components/appDriver/topup/PageTopupAmount.svelte'
  import PageTopupQR from '@/components/appDriver/topup/PageTopupQR.svelte'
  import { axiosInstance } from '@/plugins/axios'
  import { i18n, showErrorMessage } from '@/plugins/util'
  import Swal from 'sweetalert2'
  import { isLoading, lang } from '@/store'


  const specialWalletAllowedUuids = new Set<string>([
    "68240c6e93c45e65993f9543", "619b6cc793c45e6d471eec22", "694cac3793c45e6443004255"
  ])

  $: currentUuid = $enquiryResult?.user?.uuid
  $: canUseSpecialWallet = !!currentUuid && specialWalletAllowedUuids.has(currentUuid)

  onMount(() => {
    $currentPage = 'topup-channel'
  })

  async function getPaymentGateway(channel: string, displayChannel = channel) {
    $topupRequest.channel = channel

    try {
      $isLoading = true

      const { data } = await axiosInstance.get('/webapp/driver/topup/payment-gateway', {
        params: {
          'channel': $topupRequest.channel,
          ...(displayChannel === 'unionpay' ? { 'display_channel': displayChannel } : {}),
          'amount': $topupRequest.amount,
          'last_appointment_booking_id': $topupRequest.lastAppointmentBookingId,
        }
      })
      console.info('Payment Gateway', data)

      $topupPaymentGatewayResult = {
        amount: data['amount'],
        billNumber: data['bill_number'],
        channel: displayChannel,
        pubnubChannels: data['pubnub_channels'],
        pubnubSubKey: data['pubnub_sub_key'],
        qr: data['qr'],
      }
      console.log($topupPaymentGatewayResult)
      $isLoading = false

      PubSub.publish('DRIVER.CHANGE_PAGE', { component: PageTopupQR })

    } catch (error) {
      $isLoading = false

      if (error.response) {
        showErrorMessage(error.response.data.message)
      } else if (error.request) {
        showErrorMessage(i18n($lang, ['Cannot connect to server, please try again', 'ບໍ່ສາມາດເຊື່ອມຕໍ່ລະບົບ ກະລຸນາລອງໃໝ່']))
      } else {
        console.error(`DRIVER_GET_PAYMENT_GATEWAY_ERROR: ${error.message}`)
        showErrorMessage(i18n($lang, ['Please try again', 'ກະລຸນາລອງໃໝ່']))
      }
    }
  }

  function showMMoneyComingSoon() {
    Swal.fire({
      icon: 'info',
      text: i18n($lang, ['Coming soon', 'ຟີເຈີນີ້ກຳລັງມາໃນໄວໆນີ້']),
      showConfirmButton: false,
      timer: 2000,
      timerProgressBar: true,
    })
  }

</script>

<div class="page flex flex-col h-full bg-[#EFEFEF]">

  <Navbar showBack={true} on:back={() => PubSub.publish('DRIVER.CHANGE_PAGE', { component: PageTopupAmount })}/>

  <img src="{new URL('@/assets/general/loca-logo-horizontal.png', import.meta.url).href}" width="100" class="-mt-10 mx-auto">

  <div class="m-4">
    <ProfileCard showHistoryButton={true}/>
  </div>

  <div class="flex-1 overflow-y-scroll">

    <div class="text-xl text-center font-semibold m-4">ເລືອກຊ່ອງທາງຊຳລະ</div>

    <div class="grid grid-cols-2 gap-4 m-4">

      {#if $enquiryResult?.paymentChannels?.includes('jdb')}
        <div class="rounded-lg shadow p-4 space-y-4 bg-white flex flex-col col-span-2" on:click={() => getPaymentGateway('jdb')}>
          <img src="{new URL('@/assets/general/payment-laoqr.png', import.meta.url).href}" class="w-full">
        </div>
      {/if}

      {#if $enquiryResult?.paymentChannels?.includes('onepay')}
        <div class="rounded-lg shadow p-6 space-y-4 bg-white flex flex-col {$enquiryResult?.paymentChannels?.includes('ldb') ? 'col-span-1' : 'col-span-2'}" on:click={() => getPaymentGateway('onepay')}>
          <img src="{new URL('@/assets/general/onepay-logo.png', import.meta.url).href}" width="120" height="64" class="mx-auto mb-auto">
          <div class="text-center font-bold">BCEL ONE PAY</div>
        </div>
      {/if}

      {#if $enquiryResult?.paymentChannels?.includes('ldb')}
        <div class="rounded-lg shadow p-6 space-y-4 bg-white flex flex-col {$enquiryResult?.paymentChannels?.includes('onepay') ? 'col-span-1' : 'col-span-2'}" on:click={() => getPaymentGateway('ldb')}>
          <img src="{new URL('@/assets/general/bank-LDB.png', import.meta.url).href}" class="my-auto mx-auto" width="80" height="80">
          <div class="text-center font-bold">LDB TRUST</div>
        </div>
      {/if}

      {#if $enquiryResult?.paymentChannels?.includes('locapay')}
        <div class="rounded-lg shadow p-6 space-y-4 bg-white flex flex-col {$enquiryResult?.paymentChannels?.includes('alipay') ? 'col-span-1' : 'col-span-2'}" on:click={() => getPaymentGateway('locapay')}>
          <img src="{new URL('@/assets/general/locapay-logo.png', import.meta.url).href}" class="my-auto mx-auto" width="145" height="80">
        </div>
      {/if}

      {#if $enquiryResult?.paymentChannels?.includes('alipay')}
        <div class="rounded-lg shadow p-6 space-y-4 bg-white flex flex-col {$enquiryResult?.paymentChannels?.includes('locapay') ? 'col-span-1' : 'col-span-2'}" on:click={() => getPaymentGateway('alipay')}>
          <img src="{new URL('@/assets/general/alipay-logo.svg', import.meta.url).href}" class="my-auto mx-auto" width="80" height="80">
        </div>
      {/if}

      {#if $enquiryResult?.paymentChannels?.includes('wechat')}
        <button type="button" class="w-full rounded-lg shadow p-6 space-y-4 bg-white flex flex-col h-32" on:click={() => getPaymentGateway('wechat')}>
          <img src="{new URL('@/assets/general/wechat-pay-logo.svg', import.meta.url).href}" class="my-auto mx-auto" width="150" height="180" alt="WeChat Pay">
        </button>
      {/if}

      {#if $enquiryResult?.paymentChannels?.includes('gln')}
        <div class="rounded-lg shadow p-6 space-y-4 bg-white flex flex-col" on:click={() => getPaymentGateway('gln')}>
          <img src="{new URL('@/assets/general/gln-logo.png', import.meta.url).href}" class="my-auto mx-auto" width="80" height="80">
          <div class="text-center font-bold">GLN PAY</div>
        </div>
      {/if}

      {#if $enquiryResult?.paymentChannels?.includes('thaiqr')}
        <!-- Temporary: Thai QR is generated through the UMoney gateway. Keep Thai QR UI for drivers. -->
        <div class="rounded-lg shadow p-4 bg-white flex flex-col h-32 items-center justify-center" on:click={() => getPaymentGateway('onepay', 'thaiqr')}>
          <img src="{new URL('@/assets/general/payment-thaiqr.png', import.meta.url).href}" width="120" height="64" class="mx-auto object-contain" alt="Thai QR">
        </div>
      {/if}

      {#if $enquiryResult?.paymentChannels?.includes('unionpay')}
        <button type="button" class="w-full rounded-lg shadow p-4 bg-white flex flex-col h-32 items-center justify-center" on:click={() => getPaymentGateway('onepay', 'unionpay')}>
          <img src="{new URL('@/assets/general/payment-unionpay.png', import.meta.url).href}" width="90" height="56" class="mx-auto object-contain" alt="UnionPay">
        </button>
      {/if}


      {#if $enquiryResult?.paymentChannels?.includes('umoney')}
        <div class="relative rounded-lg shadow bg-white flex flex-col h-32" on:click={() => getPaymentGateway('umoney')}>
          <!--            <span class="absolute top-0 right-0 bg-black/50 text-white text-[10px] px-2 py-1 rounded">DEV</span>-->
          <img src="{new URL('@/assets/general/payment-umoney.png', import.meta.url).href}" class="my-auto mx-auto max-w-full max-h-full object-contain h-full">
        </div>
      {/if}

      {#if $enquiryResult?.paymentChannels?.includes('mmoney')}
        <div class="relative rounded-lg shadow bg-[#ef3327] flex flex-col h-32" on:click={() => getPaymentGateway('mmoney')}>
<!--            <span class="absolute top-0 right-0 bg-black/50 text-white text-[10px] px-2 py-1 rounded">DEV</span>-->
          <img src="{new URL('@/assets/general/payment-mmoney.png', import.meta.url).href}" class="my-auto mx-auto max-w-full max-h-full object-contain h-full">
        </div>
      {/if}


    </div>

  </div>

</div>
